<template>
    <div> 
    <label class="container" v-for="(option, index) in options" :key="option.text">
      <input
        :id="id + index"
        :name="id"
        type="radio"
        :value="option.value"
        :checked="option.value === value"
        :class="inputClass"
        :disabled="disabled"
        :required="required"
        @change="updateValue(option.value)"
      />
      <span class="checkmark" />
      <label :for="id + index">{{ option.text }}</label>
    </label>
    </div>
</template>
 
<script>
export default {
  model: {
    event: "change",
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number, Boolean, Object],
      default: null,
    },
    options: {
      type: [Array],
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: [String, Object],
      default: "",
    },
  },
  methods: {
    updateValue(value) {
      this.$emit("change", value);
    },
  },
};
</script>


<style lang="scss" scoped>
.container {
  display: block;
  position: relative;
  padding-left: 51px;
  height: 32px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
  line-height: 1.38;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 6px;
  left: 0;
  height: 32px;
  width: 32px;
  background-color: #fff;
  border-radius: 50%;
  border: solid 1px #d2d4e5;
}

// /* On mouse-over, add a grey background color */
// .container:hover input ~ .checkmark {
//   background-color: #ccc;
// }

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: var(--apio-purple);
  border: solid 1px var(--apio-purple);
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.container .checkmark:after {
  top: 7px;
  left: 7px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: white;
}
</style>